var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu"},[_c('div',{ref:"sideNav",staticClass:"bm-menu"},[_c('nav',{staticClass:"bm-item-list"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }